import React, { useState } from 'react';
import message from '@web-common/components/UI/Message/SiriusMessage';
import SiriusModal, { SiriusHtmlModal } from '@lingxi-common-component/sirius-ui/SiriusModal';
import styles from './bindMobile.module.scss';
import MobileValidate from '../validate/mobile';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { api, StorageKey } from 'api';
import { getIn18Text } from 'api';
const storeApi = api.getDataStoreApi();
const systemApi = api.getSystemApi();
const MobileBindModal = props => {
    const { onSuccess, setVisible, visible, currentLoginAccount } = props;
    const [visibleMobileValidate, setVisibleMobileValidate] = useState(true);
    const onValidateSuccess = (mobile) => {
        if (mobile) {
            message.success(getIn18Text('BANGDINGCHENGGONG！'));
            setTimeout(() => {
                setVisible(false);
                onSuccess();
            }, 500);
        }
        else {
            setVisible(false);
            onSuccess();
        }
    };
    if (!visible) {
        return null;
    }
    return (React.createElement("div", { className: styles.modalWrap, hidden: !visibleMobileValidate },
        React.createElement(SiriusHtmlModal, { destroyOnClose: true, visible: visible, width: 476, onCancel: () => {
                setVisible(false);
                onSuccess();
            }, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }) },
            React.createElement("div", { className: styles.wrap, hidden: !visibleMobileValidate },
                React.createElement("div", { className: styles.title, style: { marginBottom: 8 } }, getIn18Text('BANGDINGNINDESHOUJH')),
                React.createElement("div", { className: styles.subTitle }, getIn18Text('BANGDINGSHOUJIHAOHNKYTGSJHDL')),
                React.createElement(MobileValidate, { from: "loginAccount", hideMobileInput: false, onSuccess: onValidateSuccess, renderSubmitBottom: () => (React.createElement("div", { onClick: () => {
                            setVisibleMobileValidate(false);
                            setTimeout(() => {
                                SiriusModal.error({
                                    title: getIn18Text('QUEDINGXIACIDENGLJBZTXM？'),
                                    onOk: () => {
                                        var _a;
                                        const email = currentLoginAccount || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || 'global';
                                        storeApi.putSync(StorageKey.LoginSkipBindMobile, JSON.stringify({
                                            [email]: 'true',
                                        }), { noneUserRelated: true });
                                        onSuccess && onSuccess();
                                    },
                                    onCancel: () => {
                                        setTimeout(() => {
                                            setVisibleMobileValidate(true);
                                        }, 100);
                                    },
                                });
                            }, 100);
                        }, className: styles.noTip }, getIn18Text('XIACIBUZAITIX'))), isBind: true, isUpdate: false })))));
};
export default MobileBindModal;
